import { render, staticRenderFns } from "./ModalFelizAniversarioWhats.vue?vue&type=template&id=27a6b063&scoped=true&"
import script from "./ModalFelizAniversarioWhats.vue?vue&type=script&lang=js&"
export * from "./ModalFelizAniversarioWhats.vue?vue&type=script&lang=js&"
import style0 from "./ModalFelizAniversarioWhats.vue?vue&type=style&index=0&id=27a6b063&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a6b063",
  null
  
)

export default component.exports